var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"FunctionTable"},[_c('div',[(_vm.visiblessl)?_c('div',{staticClass:"Commodity_box mg_4"},[_c('ScanInput',_vm._b({ref:"fooer",attrs:{"visibles":_vm.visiblessl},on:{"dateChange":_vm.dateChangeScan}},'ScanInput',_vm.$attrs,false))],1):_vm._e()]),_vm._v(" "),_c('vxe-table',{ref:"xTable",attrs:{"data":_vm.tableData,"align":_vm.align,"highlight-cell":"","highlight-current-row":_vm.highlightcurrentrow,"border":_vm.border,"resizable":_vm.resizable,"height":_vm.tableHeight,"footer-method":_vm.footerMethod,"show-footer":_vm.showfooter,"show-overflow":"ellipsis","show-header-overflow":"","mouse-config":_vm.mouseconfig,"column-min-width":_vm.columnminwidth,"edit-config":{ trigger: 'dblclick', mode: 'cell', showStatus: true },"checkbox-config":{ checkField: 'checked' },"header-cell-style":{
      background: '#eef1f6',
      color: '#000',
      fontSize: '16px',
      height: '37px',
      padding: '0',
      fontWeight: 'bold',
    },"footer-row-style":{
      background: '#eef1f6',
      color: '#000',
      fontSize: '14px',
      height: '30px',
      padding: '0',
    },"footer-cell-style":{
      background: '#fff',
      color: '#000',
      fontSize: '14px',
      height: '30px',
      padding: '0',
    }},on:{"cell-click":_vm.cellclick,"cell-dblclick":_vm.celldblclick,"resizable-change":_vm.resizablechange}},[_c('vxe-table-column',{attrs:{"type":"index","align":"center","width":"45","fixed":"left"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('i',{staticClass:"el-icon-s-tools",staticStyle:{"color":"#2594ff","font-size":"18px"},on:{"click":function($event){_vm.tableConfigShow = true}}})]},proxy:true},{key:"default",fn:function(ref){
    var column = ref.column;
    var rowIndex = ref.rowIndex;
return [_vm._v(_vm._s(rowIndex + 1))]}}],null,false,701760254)}),_vm._v(" "),_c('vxe-table-column',{attrs:{"width":"100","align":"center","title":"操作","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var row = ref.row;
    var rowIndex = ref.rowIndex;
return [_c('el-button',{attrs:{"type":"text"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.addRow(rowIndex + 1)}}},[_vm._v("新增")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(rowIndex)}}},[_vm._v("移除")])]}}],null,false,1747899741)}),_vm._v(" "),(_vm.ImageUrlShow)?_c('vxe-table-column',{attrs:{"title":"图片","fixed":"left","width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var row = ref.row;
return [_c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center"}},[(row.ImageUrl)?_c('img',{staticStyle:{"width":"26px","height":"26px","display":"block"},attrs:{"src":row.ImageUrl},on:{"click":function($event){return _vm.imgclick(row.ImageUrl)}}}):_vm._e()])]}}],null,false,879486068)}):_vm._e(),_vm._v(" "),_vm._l((_vm.ObtainHeader),function(item,index){return [(item.Key === 'FullName' && item.Show == true)?_c('vxe-table-column',{key:index,attrs:{"width":item.Width == '' ? '200' : item.Width,"field":item.Key,"title":item.Rename},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var row = ref.row;
    var rowIndex = ref.rowIndex;
return [_c('div',{staticClass:"input_box ub ub-ac"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"autocomplete":"off","id":'x_' + rowIndex + '_y_' + index,"size":"mini","type":"text"},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                  row,
                  rowIndex,
                  index,
                  item.FirstOne,
                  item.LastOne,
                  _vm.Obtain.length
                )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                  row,
                  rowIndex,
                  index,
                  item.FirstOne,
                  item.LastOne,
                  _vm.Obtain.length
                )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                  row,
                  rowIndex,
                  index,
                  item.FirstOne,
                  item.LastOne,
                  _vm.Obtain.length
                )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                  row,
                  rowIndex,
                  index,
                  item.FirstOne,
                  item.LastOne,
                  _vm.Obtain.length
                )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                  row,
                  rowIndex,
                  index,
                  item.FirstOne,
                  item.LastOne,
                  _vm.Obtain.length
                )}],"keydown":_vm.EnterArrows,"dblclick":_vm.ChoiceClick,"focus":function($event){return _vm.doFocus(
                  $event,
                  row.BaseCode,
                  rowIndex,
                  item.Key,
                  row[item.Key],
                  row
                )},"blur":function($event){return _vm.doblurs(
                  $event,
                  row.BaseCode,
                  rowIndex,
                  item.Key,
                  row[item.Key],
                  row
                )},"change":[function($event){return _vm.$set(row, item.Key, $event.target.value)},function($event){return _vm.change(row[item.Key])}]}}),_vm._v(" "),(
                item.Key == 'FullName' &&
                item.Show == true &&
                rowIndex === _vm.rowIndexX
              )?_c('span',{staticClass:"cliclicon el-icon-more",on:{"click":_vm.ChoiceClick}}):_vm._e()])]}}],null,true)}):_vm._e(),_vm._v(" "),(item.Key === 'BaseCode' && item.Show == true)?_c('vxe-table-column',{key:index,attrs:{"width":item.Width == '' ? '200' : item.Width,"field":item.Key,"title":item.Rename},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_vm._v("\n            "+_vm._s(item.Rename)+"\n            "),_c('el-button',{staticClass:"btnclick",attrs:{"slot":"reference"},on:{"click":_vm.clickbtn},slot:"reference"},[_vm._v("扫码录入")])],1)]},proxy:true},{key:"default",fn:function(ref){
              var row = ref.row;
return [_c('div',{staticClass:"only_show_div"},[_vm._v(_vm._s(row[item.Key]))])]}}],null,true)}):_vm._e(),_vm._v(" "),(item.Key === 'UnitName' && item.Show == true)?_c('vxe-table-column',{key:index,attrs:{"width":item.Width == '' ? '200' : item.Width,"field":item.Key,"title":item.Rename},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var row = ref.row;
              var rowIndex = ref.rowIndex;
return [_c('div',{staticClass:"box_popover",staticStyle:{"position":"relative"}},[_c('span',{staticClass:"only_show_div"},[_vm._v(_vm._s(row[item.Key]))]),_vm._v(" "),(
                row.FullName != '' &&
                row.BaseCode != '' &&
                item.Key == 'UnitName' &&
                item.Show == true &&
                rowIndex == _vm.rowIndexX &&
                _vm.$attrs.pargam.Model != 'TakeStock'
              )?_c('el-popover',{staticStyle:{"position":"absolute","top":"-3px","right":"10px"},model:{value:(_vm.visiblepopover),callback:function ($$v) {_vm.visiblepopover=$$v},expression:"visiblepopover"}},[_c('div',[_c('vxe-table',{attrs:{"border":"","highlight-hover-row":"","data":_vm.rowUnitData,"height":"200px"},on:{"cell-click":_vm.cellclickddw}},[_vm._l((_vm.ObtainHeaderddw),function(item,index){return [_c('vxe-table-column',{key:index,attrs:{"width":"90","field":item.Key,"title":item.Rename,"align":"center"}})]})],2)],1),_vm._v(" "),(
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'UnitName' &&
                  item.Show == true
                )?_c('span',{staticClass:"btnclicks el-icon-more",staticStyle:{"padding":"10px 0"},attrs:{"slot":"reference"},on:{"click":function($event){return _vm.visiblepop(row)}},slot:"reference"}):_vm._e()]):_vm._e()],1)]}}],null,true)}):_vm._e(),_vm._v(" "),(
          item.Key != 'FullName' &&
          item.Key != 'BaseCode' &&
          item.Key != 'UnitName' &&
          item.Show == true
        )?_c('vxe-table-column',{key:index,attrs:{"width":item.Width,"title":item.Rename,"field":item.Key,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var row = ref.row;
        var rowIndex = ref.rowIndex;
return [_c('div',{staticClass:"input_box ub ub-ac"},[(
                row.FullName != '' &&
                row.BaseCode != '' &&
                item.Key == 'KtypeIdName' &&
                _vm.$attrs.pargam.Model != 'TakeStock'
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"dblclick":function($event){return _vm.clickAboveattrs(
                  row,
                  rowIndex,
                  index,
                  row.IsSerial,
                  row.CostType
                )}}},[_c('div',{staticClass:"only_show_div"},[_vm._v(_vm._s(row[item.Key]))]),_vm._v(" "),(
                  _vm.$attrs.pargam.Model != 'SaleOrder' &&
                  _vm.$attrs.pargam.Model != 'BuyOrder' &&
                  rowIndex === _vm.rowIndexX
                )?_c('span',{staticClass:"cliclicon el-icon-more",on:{"click":function($event){return _vm.clickAboveattrs(
                    row,
                    rowIndex,
                    index,
                    row.IsSerial,
                    row.CostType
                  )}}}):_vm._e()]):_vm._e(),_vm._v(" "),(
                row.FullName != '' &&
                row.BaseCode != '' &&
                item.Key == 'Qty' &&
                _vm.$attrs.pargam.Model != 'TakeStock'
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"dblclick":function($event){return _vm.clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)}}},[(
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'Qty' &&
                  _vm.$attrs.pargam.Model != 'TakeStock' &&
                  (row.IsSerial == false ||
                    _vm.$attrs.pargam.Model == 'SaleOrder' ||
                    _vm.$attrs.pargam.Model == 'BuyOrder')
                )?_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","id":'x_' + rowIndex + '_y_' + index,"type":"text","autocomplete":"off"},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"blur":function($event){return _vm.changeData(
                    row,
                    index,
                    item.Key,
                    row[item.Key],
                    row.CostType,
                    row.IsSerial
                  )},"change":[function($event){return _vm.$set(row, item.Key, $event.target.value)},function($event){$event.stopPropagation();row[item.Key] = row[item.Key].replace(
                    /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                    '$1'
                  )}]}}):_c('div',{staticClass:"only_show_div"},[_vm._v(_vm._s(row[item.Key]))]),_vm._v(" "),(
                  _vm.$attrs.pargam.Model != 'SaleOrder' &&
                  _vm.$attrs.pargam.Model != 'BuyOrder' &&
                  rowIndex === _vm.rowIndexX
                )?_c('span',{staticClass:"cliclicon el-icon-more",on:{"click":function($event){return _vm.clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)}}}):_vm._e()]):_vm._e(),_vm._v(" "),(
                row.FullName != '' &&
                row.BaseCode != '' &&
                item.Key == 'AQty' &&
                _vm.$attrs.pargam.Model == 'TakeStock'
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"dblclick":function($event){return _vm.clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)}}},[(
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'AQty' &&
                  _vm.$attrs.pargam.Model == 'TakeStock' &&
                  row.IsSerial == false
                )?_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","id":'x_' + rowIndex + '_y_' + index,"type":"text","autocomplete":"off"},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"blur":function($event){return _vm.changeData(
                    row,
                    index,
                    item.Key,
                    row[item.Key],
                    row.CostType,
                    row.IsSerial
                  )},"change":[function($event){return _vm.$set(row, item.Key, $event.target.value)},function($event){$event.stopPropagation();row[item.Key] = row[item.Key].replace(
                    /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                    '$1'
                  )}]}}):_c('div',{staticClass:"only_show_div"},[_vm._v(_vm._s(row[item.Key]))]),_vm._v(" "),(
                  _vm.$attrs.pargam.Model != 'SaleOrder' &&
                  _vm.$attrs.pargam.Model != 'BuyOrder' &&
                  rowIndex === _vm.rowIndexX
                )?_c('span',{staticClass:"cliclicon el-icon-more",on:{"click":function($event){return _vm.clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)}}}):_vm._e()]):(
                row.FullName != '' &&
                row.BaseCode != '' &&
                item.Key == 'Total' &&
                row.PStutas !== '赠品'
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","type":"text","autocomplete":"off","id":'x_' + rowIndex + '_y_' + index},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"blur":function($event){return _vm.changeData(
                    row,
                    index,
                    item.Key,
                    row[item.Key],
                    row.CostType,
                    row.IsSerial
                  )},"change":[function($event){return _vm.$set(row, item.Key, $event.target.value)},function($event){$event.stopPropagation();row[item.Key] = row[item.Key].replace(
                    /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                    '$1'
                  )}]}})]):(
                row.Name != '' &&
                row.BaseCode != '' &&
                (item.Key == 'Memo' ||
                  item.Key == 'BString1' ||
                  item.Key == 'BString2' ||
                  item.Key == 'BString3' ||
                  item.Key == 'BString4' ||
                  item.Key == 'BString5')
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","type":"text","autocomplete":"off","id":'x_' + rowIndex + '_y_' + index},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"change":function($event){return _vm.$set(row, item.Key, $event.target.value)}}})]):(
                row.Name != '' &&
                row.BaseCode != '' &&
                (item.Key == 'Discount' ||
                  item.Key == 'DiscountPrice' ||
                  item.Key == 'DiscountTotal' ||
                  item.Key == 'WithTaxTotal' ||
                  item.Key == 'TaxPrice') &&
                row.PStutas !== '赠品'
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","type":"text","autocomplete":"off","id":'x_' + rowIndex + '_y_' + index},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"blur":function($event){return _vm.changeData(
                    row,
                    index,
                    item.Key,
                    row[item.Key],
                    row.CostType,
                    row.IsSerial
                  )},"change":[function($event){return _vm.$set(row, item.Key, $event.target.value)},function($event){$event.stopPropagation();row[item.Key] = row[item.Key].replace(
                    /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                    '$1'
                  )}]}})]):(
                row.Name != '' &&
                row.BaseCode != '' &&
                row.PStutas != '赠品' &&
                item.Key == 'Tax'
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","type":"text","autocomplete":"off","id":'x_' + rowIndex + '_y_' + index},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"blur":function($event){return _vm.changeData(
                    row,
                    index,
                    item.Key,
                    row[item.Key],
                    row.CostType,
                    row.IsSerial
                  )},"change":[function($event){return _vm.$set(row, item.Key, $event.target.value)},function($event){$event.stopPropagation();row[item.Key] = row[item.Key].replace(
                    /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                    '$1'
                  )}]}})]):_vm._e(),_vm._v(" "),(
                row.FullName != '' &&
                row.BaseCode != '' &&
                item.Key == 'JobNumber' &&
                !_vm.CombineBatch &&
                row.CostType == 1
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"dblclick":function($event){return _vm.clickJobNumber(row, rowIndex, index, row[item.Key])}}},[(
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'JobNumber' &&
                  _vm.$attrs.pargam.Documenttype == 1 &&
                  row.CostType == 1 &&
                  _vm.$attrs.pargam.Model != 'BuyOrder' &&
                  _vm.$attrs.pargam.Model != 'SaleOrder'
                )?_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","id":'x_' + rowIndex + '_y_' + index,"type":"text","autocomplete":"off"},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"change":function($event){return _vm.$set(row, item.Key, $event.target.value)}}}):_c('div',{staticClass:"only_show_div"},[_vm._v(_vm._s(row[item.Key]))]),_vm._v(" "),(
                  _vm.$attrs.pargam.Model != 'SaleOrder' &&
                  _vm.$attrs.pargam.Model != 'BuyOrder' &&
                  _vm.$attrs.pargam.Documenttype == 0 &&
                  rowIndex === _vm.rowIndexX &&
                  !_vm.CombineBatch
                )?_c('span',{staticClass:"cliclicon el-icon-more",on:{"click":function($event){return _vm.clickJobNumber(row, rowIndex, index, row[item.Key])}}}):_vm._e()]):(
                row.Name != '' && row.BaseCode != '' && item.Key == 'PStutas'
              )?_c('div',{staticClass:"only_show_div"},[_c('el-select',{attrs:{"placeholder":"请选择","size":"mini"},on:{"change":function($event){return _vm.selcetChange($event, row, rowIndex)}},model:{value:(row[item.Key]),callback:function ($$v) {_vm.$set(row, item.Key, $$v)},expression:"row[item.Key]"}},[_c('el-option',{attrs:{"label":"非赠品","value":"非赠品"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"赠品","value":"赠品"}})],1)],1):(
                row.FullName != '' &&
                row.BaseCode != '' &&
                item.Key == 'ShowPrice' &&
                row.PStutas !== '赠品'
              )?_c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"dblclick":function($event){return _vm.Choicedj(row, rowIndex, index)}}},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(row[item.Key]),expression:"row[item.Key]",modifiers:{"lazy":true}}],ref:"Qtyfocus",refInFor:true,staticClass:"input_stys",attrs:{"size":"mini","type":"text","autocomplete":"off","id":'x_' + rowIndex + '_y_' + index},domProps:{"value":(row[item.Key])},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length,
                    item.Key
                  )},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==37){ return null; }return _vm.LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==39){ return null; }return _vm.EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    _vm.Obtain.length
                  )}],"keydown":_vm.EnterArrows,"focus":function($event){return _vm.doFocu($event, row.BaseCode, row[item.Key])},"blur":function($event){return _vm.changeData(
                    row,
                    index,
                    item.Key,
                    row[item.Key],
                    row.CostType,
                    row.IsSerial
                  )},"change":[function($event){return _vm.$set(row, item.Key, $event.target.value)},function($event){$event.stopPropagation();row[item.Key] = row[item.Key].replace(
                    /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                    '$1'
                  )}]}}),_vm._v(" "),(rowIndex === _vm.rowIndexX)?_c('span',{staticClass:"cliclicon el-icon-more",on:{"click":function($event){return _vm.Choicedj(row, rowIndex, index)}}}):_vm._e()]):(
                row.FullName != '' &&
                row.BaseCode != '' &&
                (item.Key == 'OutFactoryDate' ||
                  item.Key == 'MaturityDate') &&
                _vm.$attrs.pargam.Documenttype == 1 &&
                !_vm.CombineBatch &&
                row.CostType == 1 &&
                _vm.$attrs.pargam.Model != 'BuyOrder' &&
                _vm.$attrs.pargam.Model != 'SaleOrder'
              )?_c('div',{staticClass:"input_box_picker",staticStyle:{"width":"100%","height":"100%"}},[_c('el-date-picker',{ref:"Qtyfocus",refInFor:true,attrs:{"type":"date","value-format":"yyyy-MM-dd"},on:{"change":function($event){return _vm.changepicker($event, row, item.Key, rowIndex)},"focus":function($event){return _vm.focuscilic($event, rowIndex, index, item.Key)}},model:{value:(row[item.Key]),callback:function ($$v) {_vm.$set(row, item.Key, $$v)},expression:"row[item.Key]"}})],1):_c('div',{staticClass:"only_show_div"},[_vm._v(_vm._s(row[item.Key]))])])]}}],null,true)}):_vm._e()]})],2),_vm._v(" "),_c('GoodsTables',_vm._b({ref:"GoodsTables",attrs:{"textname":_vm.textname,"show":_vm.searchShow,"tableDataPtyId":_vm.tableData},on:{"update:show":function($event){_vm.searchShow=$event},"dbclickRow":_vm.chooseBack,"chooseBack":_vm.chooseBack}},'GoodsTables',_vm.$attrs,false)),_vm._v(" "),_c('SerialTable',_vm._b({ref:"SerialTable",attrs:{"show":_vm.SerialTableShow,"qtys":_vm.qtys,"vchtype":_vm.vchtype,"tableDatasl":_vm.tableDatasl,"tableDatarow":_vm.tableDatarow},on:{"update:show":function($event){_vm.SerialTableShow=$event},"chooseBack":_vm.Databackfilling}},'SerialTable',_vm.$attrs,false)),_vm._v(" "),_c('Multiple',_vm._b({ref:"Multiple",attrs:{"show":_vm.MultipleShow,"qtys":_vm.qtys,"vchtype":_vm.vchtype,"tableDatasl":_vm.tableDatasl,"tableDatarow":_vm.tableDatarow},on:{"update:show":function($event){_vm.MultipleShow=$event},"chooseBack":_vm.Databackfilling}},'Multiple',_vm.$attrs,false)),_vm._v(" "),_c('HeaderElastic',_vm._g(_vm._b({attrs:{"show":_vm.tableConfigShow,"tableData":_vm.ObtainHeader},on:{"update:show":function($event){_vm.tableConfigShow=$event},"restoreDefault":_vm.restoreDefault}},'HeaderElastic',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),_c('UnitPrice',_vm._b({attrs:{"show":_vm.tableUnitPrice,"searchData":_vm.searchData},on:{"update:show":function($event){_vm.tableUnitPrice=$event},"chooseBack":_vm.chooseBackUnitPrice}},'UnitPrice',_vm.$attrs,false)),_vm._v(" "),_c('batchDialog',_vm._b({attrs:{"show":_vm.tablebatchDialog,"Goodsdata":_vm.Goodsdata,"tableData":_vm.GoodstableData},on:{"update:show":function($event){_vm.tablebatchDialog=$event},"chooseBack":_vm.chooseBackbatchDialog}},'batchDialog',_vm.$attrs,false)),_vm._v(" "),_c('batchDialog',_vm._b({attrs:{"show":_vm.tablebatchDialogs,"Goodsdata":_vm.Goodsdata,"tableData":_vm.GoodstableData},on:{"update:show":function($event){_vm.tablebatchDialogs=$event},"chooseBack":_vm.chooseBackbatchDialogs}},'batchDialog',_vm.$attrs,false)),_vm._v(" "),_c('Searchpop',_vm._b({attrs:{"show":_vm.addShow,"searchData":_vm.search_Data},on:{"update:show":function($event){_vm.addShow=$event},"dbclickRow":_vm.choose_Back,"chooseBack":_vm.choose_Back}},'Searchpop',_vm.$attrs,false)),_vm._v(" "),_c('el-dialog',{staticClass:"image_sty",attrs:{"visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('img',{attrs:{"width":"100%","src":_vm.dialogImageUrl,"alt":""}})])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63b869a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table/FunctionTable/FunctionTable.vue
// module id = null
// module chunks = 